// ErrorDisplay.tsx

import { ErrorDisplayProps } from '@/types'


const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message }) => {
  return <div>Error: {message}</div>;
};

export default ErrorDisplay;
